import bind from 'bind-decorator';
import { History } from 'history';
import { action, observable } from 'mobx';
import * as React from 'react';
import { API, APIErrorMap, LoginResponse, LoginValidationErrorKeys, nonFieldErrorsKey } from '../api/api';
import { unreachable } from '../utils/compose';
import { AppStore } from './app-store';

// tslint:disable:readonly-keyword

export class LoginStore {
  @observable public pnr = '';
  @observable public lastName = '';
  @observable public loading = false;
  @observable public lastLoginErrors: APIErrorMap<LoginValidationErrorKeys> = {};

  constructor(private readonly history: History, private readonly api: API, private readonly app: AppStore) {}

  @bind
  @action
  public setPNR(pnr: string) {
    this.pnr = pnr;
  }

  @bind
  @action
  public setLastName(lastName: string) {
    this.lastName = lastName;
  }

  @bind
  @action
  public async handleClickLogin(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    this.lastLoginErrors = {};
    this.loading = true;

    const response = await this.api.login(this.pnr, this.lastName);
    await this.handleLoginResponse(response);
  }

  // tslint:disable:cyclomatic-complexity
  @action
  public async handleLoginResponse(response: LoginResponse) {
    this.loading = false;

    switch (response.status) {
      case 'ok':
        this.app.storeSuccessfulLogin(this.pnr, this.lastName, response.booking);
        this.history.push('/segment');
        break;

      case 'not-found':
        this.displayLoginError('Could not locate PNR and/or last name.');
        break;

      case 'ineligible':
        this.displayLoginError('Unfortunately, your booking is not eligible for a voucher.');
        break;

      case 'expired':
        this.history.push('/expired');
        break;

      case 'unexpected-error':
        this.displayLoginError('Error looking up booking. Please try again later.');
        break;

      case 'validation-error':
        this.lastLoginErrors = response.errors;
        break;

      case 'network-error':
        this.displayLoginError('Error looking up booking. Please try again later.');
        break;

      default:
        unreachable(response);
        break;
    }
  }

  private displayLoginError(message: string) {
    this.lastLoginErrors = { [nonFieldErrorsKey]: [message] };
  }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/stores/login-store.tsx